import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const RoleClaimsDialogTourConfig: AgTechTourConfig = {
    id: 'role-claims-dialog-tour',
    name: 'Role Permissions Tour',
    steps: [
        {
            targetId: 'role-claims-grid',
            title: 'Permissions',
            description: 'Everything this role allows, each with a plain-English description. This list is read-only; roles are defined by your administrator.',
            position: 'top',
        },
    ]
}
